var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isAuthenticated())?_c('Sidebar'):_vm._e(),_c('div',{class:_vm.getAppClass(),attrs:{"id":"app"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }